<template>
  <v-card outlined class="elevation-0 mx-6 mb-6 table-container">
    <v-data-table
      no-data-text="Không có dữ liệu"
      :headers="headers"
      :items="studentsData"
      :loading="loading"
      :items-per-page="10"
      fixed-header
      height="500px"
      class="elevation-0 pa-0 custom-table"
      :footer-props="{ 'items-per-page-text': 'Số dòng mỗi trang', itemsPerPageAllText: 'Tất cả' }"
    >
      <template v-slot:[`item.birthDay`]="{ item }">
        {{ formatDate(item.birthDay) }}
      </template>
      <template v-for="(lesson, index) in lessonHeaders" v-slot:[`item.lesson${index}`]="{ item }">
        <div v-if="item.lessons[index]" :key="index" class="lesson-details">
          <div class="d-flex">
            <div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-if="item.lessons[index].attendance !== undefined"
                    :color="getAttendanceColor(item.lessons[index].attendance)"
                    class="attendance-icon"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ getAttendanceIcon(item.lessons[index].attendance) }}
                  </v-icon>
                </template>
                <span>Điểm danh: {{ getAttendanceText(item.lessons[index].attendance) }}</span>
              </v-tooltip>
            </div>
            <div>
              <div v-if="item.lessons[index].evaluate.length > 0">
                <div v-for="(evaluate, evalIndex) in item.lessons[index].evaluate" :key="evalIndex">
                  <div>
                    <div
                      v-for="(criteria, criteriaIndex) in evaluate.evaluate_criteria"
                      :key="criteria.id"
                      class="mr-2"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip class="criteria-chip" color="secondary" text-color="white" v-bind="attrs" v-on="on">
                            <strong>{{ criteria.title.charAt(0) }}:</strong>
                            {{ evaluate.evaluate_value[criteriaIndex].value }}
                          </v-chip>
                        </template>
                        <span>{{ criteria.title }}: {{ evaluate.evaluate_value[criteriaIndex].value }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { isArray } from 'lodash-es'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    query: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      baseHeaders: [
        { text: 'Tên học sinh', value: 'studentName' },
        { text: 'Ngày sinh', value: 'birthDay' },
      ],
      lessonHeaders: [],
      evaluateDialogVisible: false,
      selectedLesson: null,
    }
  },
  computed: {
    ...mapGetters('evaluate', ['getStatistics', 'isLoading']),
    studentsData() {
      return this.getStatistics || []
    },
    loading() {
      return this.isLoading
    },
    headers() {
      return [...this.baseHeaders, ...this.lessonHeaders]
    },
  },
  watch: {
    query: {
      handler() {
        this.fetchData()
      },
      deep: true,
    },
    studentsData: {
      handler() {
        this.generateLessonHeaders()
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions('evaluate', ['statisticEvaluate']),
    async fetchData() {
      if (this.query && this.query.classId && this.query.lessonIds && this.query.lessonIds.length > 0) {
        await this.statisticEvaluate(this.query)
      }
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('vi-VN')
    },
    generateLessonHeaders() {
      if (this.studentsData.length > 0) {
        const maxLessons = Math.max(...this.studentsData.map((student) => student.lessons.length))
        this.lessonHeaders = Array.from({ length: maxLessons }, (_, index) => ({
          text: `Buổi học ${index + 1}`,
          value: `lesson${index}`,
          sortable: false,
          width: '350px', // Set equal width for all lesson columns
        }))
        this.studentsData.forEach((student) => {
          student.lessons.forEach((lesson, index) => {
            this.lessonHeaders[index].text = `${lesson.classTitle} - ${lesson.startTime} - ${this.formatDate(
              lesson.lessonDate
            )}`
          })
        })
      }
    },
    getAttendanceColor(attendance) {
      return attendance === 'attended' ? 'green' : attendance === 'absent' ? 'red' : 'grey'
    },
    getAttendanceIcon(attendance) {
      return attendance === 'attended'
        ? 'mdi-check-circle'
        : attendance === 'absent'
        ? 'mdi-close-circle'
        : 'mdi-help-circle'
    },
    getAttendanceText(attendance) {
      return attendance === 'attended' ? 'Có mặt' : attendance === 'absent' ? 'Vắng mặt' : 'Chưa điểm danh'
    },
    getEvaluate(value) {
      if (isArray(value)) {
        return value.join()
      }
      return value
    },
  },
  created() {
    this.fetchData()
  },
}
</script>

<style scoped>
.headline {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}

.lesson-details {
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
  height: -webkit-fill-available;
}

.attendance-icon {
  margin-top: 5px;
  margin-bottom: 10px;
  font-size: 24px;
}

.criteria-chip {
  width: fit-content;
  margin: 5px 0;
  padding: 10px;
}

.v-data-table {
  padding: 20px;
}

.v-data-table-header {
  padding: 10px;
}

.v-data-table__wrapper {
  padding: 10px;
}

.v-data-table__progress {
  padding: 10px;
}
.table-container {
  overflow-x: auto;
  max-width: 100%;
}

/* Chỉnh sửa bảng */
.custom-table ::v-deep(th),
.custom-table ::v-deep(td) {
  white-space: normal !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important; 
}

/* Cố định cột đầu tiên */
.custom-table ::v-deep(th:nth-child(1)),
.custom-table ::v-deep(td:nth-child(1)) {
  position: sticky;
  left: 0;
  min-width: 150px;
}

/* Cố định cột thứ hai */
.custom-table ::v-deep(th:nth-child(2)),
.custom-table ::v-deep(td:nth-child(2)) {
  position: sticky;
  left: 150px;
  min-width: 100px;
}
.custom-table ::v-deep(td:nth-child(1)),
.custom-table ::v-deep(td:nth-child(2)){
  background: white;
  z-index: 2;

}
.custom-table ::v-deep(th:nth-child(1)),
.custom-table ::v-deep(th:nth-child(2)){
  background: #f5f5f5 !important;
  z-index: 5;

}
.custom-table ::v-deep(th){
  background: #f5f5f5 !important;

}

</style>
